import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@keen.io/typography';
import { Input } from '@keen.io/ui-core';
import { ControlContainer, Row, Container } from './PrefixAndSuffix.styles';

var PrefixAndSuffix = function PrefixAndSuffix(_ref) {
  var onChange = _ref.onChange,
      prefix = _ref.prefix,
      suffix = _ref.suffix;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var onPrefixChange = function onPrefixChange(e) {
    var inputValue = e.currentTarget.value;
    onChange({
      suffix: suffix,
      prefix: inputValue
    });
  };

  var onSuffixChange = function onSuffixChange(e) {
    var inputValue = e.currentTarget.value;
    onChange({
      suffix: inputValue,
      prefix: prefix
    });
  };

  return React.createElement(Container, null, React.createElement(Row, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.prefix')), React.createElement(ControlContainer, null, React.createElement(Input, {
    "data-testid": "input-prefix",
    value: prefix || '',
    variant: "solid",
    placeholder: t('widget_customization_format_value_settings.text_placeholder'),
    onChange: function onChange(e) {
      return onPrefixChange(e);
    }
  }))), React.createElement(Row, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.suffix')), React.createElement(ControlContainer, null, React.createElement(Input, {
    "data-testid": "input-suffix",
    value: suffix || '',
    variant: "solid",
    placeholder: t('widget_customization_format_value_settings.text_placeholder'),
    onChange: function onChange(e) {
      return onSuffixChange(e);
    }
  }))));
};

export default PrefixAndSuffix;